export const DEFAULT_DEV_BOT = {
  id: '2ea028d0-042a-4cec-a1a2-ca1d72a4cb3d',
  orgId: 1,
  name: 'Netomi Dev AI Agent',
};

export const DEFAULT_DEV_ACCESS_TOKEN = 'access-token=dev-local-token';

export const DEFAULT_DEV_PASSPORT_USER = {
  id: 5,
  orgId: 1,
  firstName: 'Passport',
  lastName: 'OrgAdmin',
  email: 'passport.orgadmin@netomi.com',
  uuid: '70a1e848-adab-11ee-b19d-02f93e00b40b',
  settings: null,
  policy: null,
  managerUserId: null,
  active: 1,
  createdAt: '2024-01-07T22:29:05.000Z',
  updatedAt: '2025-01-02T06:53:57.000Z',
  org: {
    id: 1,
    name: 'Netomi',
    type: 'Provider',
    ssoConfigId: 1,
    settings: {
      logoUrl: 'https://clustering-files.s3.amazonaws.com/logos/32-int-netomi.png',
      orgDomains: ['netomi.com', 'gmail.com'],
      approvedDomains: ['netomi.com', 'gmail.com', 'netomi.org', 'netomi-ai.com', 'yahoo.com'],
    },
    policy: {
      version: '2024-09-24',
      statements: [
        {
          name: 'studio-allow-org',
          roles: ['Studio Org Admin'],
          effect: 'allow',
          actions: ['CreateAiAgent'],
          resources: ['studio/ai-agent'],
        },
        {
          name: 'studio-allow-themes',
          effect: 'veto-allow',
          actions: ['ViewThemes'],
          resources: ['studio/settings'],
        },
      ],
    },
    active: 1,
  },
  roles: [
    {
      id: 2,
      name: 'Studio Org Admin',
      description:
        'OrgAdmin for all Studio features, applicable only to the AI Agents owned by the Org',
      tags: 'Studio,OrgAdmin',
      active: 1,
      userRoles: [
        {
          id: 593,
          userId: 5,
          uuid: '70a1e848-adab-11ee-b19d-02f93e00b40b',
          roleId: 2,
          orgId: 1,
          orgDivisionId: null,
          active: 1,
          botId: null,
          org: {
            id: 1,
            name: 'Netomi',
            policy: {
              version: '2024-09-24',
              statements: [
                {
                  name: 'studio-allow-org',
                  roles: ['Studio Org Admin'],
                  effect: 'allow',
                  actions: ['CreateAiAgent'],
                  resources: ['studio/ai-agent'],
                },
                {
                  name: 'studio-allow-themes',
                  effect: 'veto-allow',
                  actions: ['ViewThemes'],
                  resources: ['studio/settings'],
                },
              ],
            },
          },
        },
      ],
      policies: [
        {
          id: 2,
          name: 'studio/bots/org-admin',
          description: 'Allows access to all Studio features for AI Agents owned by the user',
          version: '2024-09-24',
          policy: {
            version: '2024-09-24',
            statements: [
              {
                name: 'studio-org-admin-allow',
                effect: 'allow',
                actions: [
                  'OrgAdmin',
                  'Create*',
                  'Update*',
                  'Read*',
                  'View*',
                  'Clone*',
                  'Delete*',
                  'Import*',
                  'Export*',
                  'Upload*',
                  'Download*',
                  'Deploy*',
                  'Receive*',
                  'Run*',
                  'Unlock*',
                ],
                resources: ['studio/*/*'],
              },
              {
                name: 'studio-org-admin-deny',
                effect: 'deny',
                actions: [
                  'CreateAiAgent',
                  'ViewHomeIcon',
                  'ViewAccount',
                  'ViewUserProfile',
                  'ViewTeam',
                  'UpdateAccount',
                  'CreateAccount',
                  'ViewThemes',
                  'ViewTestSet',
                ],
                resources: ['studio/bots', 'studio/settings', 'studio/ai-agent', 'studio/actions'],
              },
            ],
          },
        },
      ],
    },
  ],
  permittedOrgs: [1],
  traceId: 'da8837b4-c793-4aee-b8c3-16c13e7f836b',
  defaultBotId: 'a8163d75-ebda-4409-a367-ff7325c9bded',
};
